import { render, staticRenderFns } from "./MenuEstrazioni.vue?vue&type=template&id=9b19de34&"
import script from "./MenuEstrazioni.vue?vue&type=script&lang=js&"
export * from "./MenuEstrazioni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports